import React from 'react';

const NebulaUltraLogFormModal = React.lazy(() => import('../components/FormModal'));
const nebulaUltraLogModalRegistry = {
    personalize_nebulaUltraLogId: NebulaUltraLogFormModal
};
export default nebulaUltraLogModalRegistry;

